import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description BlankStamp icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { BlankStamp } from '@sravni/design-system-icons'
 *
 * <BlankStamp />
 * ```
 */
var BlankStamp = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "BlankStamp", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M15.238 6.508V3.89c0-.965-.781-1.746-1.746-1.746H3.889c-.965 0-1.746.781-1.746 1.746v12.222c0 .965.78 1.746 1.746 1.746h2.619", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M6.071 14.365a1.31 1.31 0 1 1 .001-2.62 1.31 1.31 0 0 1 0 2.62ZM17.857 16.623v-.756c0-.375-.24-.71-.597-.828l-2.022-.674V12.62l.609-.39A1.21 1.21 0 0 0 15.194 10h-2.53a1.21 1.21 0 0 0-.653 2.23l.608.389v1.746l-2.022.674a.872.872 0 0 0-.597.829v.755a.87.87 0 0 0 .256.617l.361.361a.872.872 0 0 0 .617.256h5.389a.87.87 0 0 0 .617-.256l.361-.361a.872.872 0 0 0 .256-.617ZM4.762 5.635h6.984M4.762 8.69h3.492", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { BlankStamp };
//# sourceMappingURL=BlankStamp.js.map
